import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd } from "@/lib/seo";
import { FAQS_ANALYTICS_AI } from "@/lib/service-content/faqs/analytics-ai";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/analitica-ai";

export const Route = createFileRoute("/es/analitica-ai")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Analítica Shopify e IA Aplicada: Medición y Decisiones · Shugert",
    description: "Analítica Shopify, conciliación con GA4, medición de clientes e IA aplicada con definiciones, validación y ownership humano explícitos.",
    path: PATH,
    altPath: alternatePath(PATH, "en"),
    ogImage: "/og-default-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Analítica e IA", path: PATH }]),
      faqJsonLd(FAQS_ANALYTICS_AI.es),
      serviceJsonLd({
        name: "Analítica Shopify e IA Aplicada",
        description: "Contratos de medición, conciliación Shopify y GA4, superficies de decisión y prototipos de IA aplicada validados con ownership humano.",
        path: PATH,
        serviceType: "E-commerce Analytics and Applied AI",
        minPrice: 1500,
        unit: "PROJECT",
        deliverables: ["Inventario de preguntas comerciales", "Contrato de medición", "Plan de datos y eventos", "Superficie de decisión", "Brief de modelo o automatización cuando se justifica"],
        locale: "es",
      }),
    ],
  }),
});
